export default __webpack_public_path__ + "static/media/SWT0040.34I-41105_-24398_0.f3f21ff5.jpg";